var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadingBg08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500.02 121.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-10,.cls-11,.cls-2,.cls-3,.cls-4,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-2,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{mix-blend-mode:multiply;}.cls-2{fill:url(#radial-gradient);}.cls-3{fill:url(#New_Gradient_Swatch_92);}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:#b7805c;}.cls-11,.cls-5{opacity:0.5;}.cls-6,.cls-7,.cls-8,.cls-9{opacity:0.65;}.cls-6{fill:url(#New_Gradient_Swatch_88);}.cls-7{fill:url(#New_Gradient_Swatch_88-2);}.cls-8{fill:url(#New_Gradient_Swatch_88-3);}.cls-9{fill:url(#radial-gradient-2);}.cls-10,.cls-11{mix-blend-mode:screen;}.cls-10{fill:url(#New_Gradient_Swatch_90);}.cls-11{fill:#ca9e67;}.cls-12{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 145.8,
    cy: 68.85,
    r: 237.43,
    gradientTransform: "translate(29.55) scale(1.48 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a48a7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_92",
    x1: 245.68,
    y1: 102.13,
    x2: 245.68,
    y2: 18.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#692705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823b00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 245.68,
    y1: 95.73,
    x2: 245.68,
    y2: 10.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a14c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59547"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_88",
    cx: -13.71,
    cy: -19.11,
    r: 73.59,
    gradientTransform: "translate(29.55) scale(1.48 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfa04d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_88-2",
    cx: 23.59,
    cy: -20.04,
    r: 133.54,
    xlinkHref: "#New_Gradient_Swatch_88"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_88-3",
    cx: 59.62,
    cy: -25.67,
    r: 189.63,
    xlinkHref: "#New_Gradient_Swatch_88"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 138.33,
    cy: -14.55,
    r: 229.36,
    xlinkHref: "#New_Gradient_Swatch_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_90",
    x1: 11.76,
    y1: 43.58,
    x2: 429.05,
    y2: 43.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a48a7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 27.95,
    y1: 54.87,
    x2: 462.38,
    y2: 54.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf9f7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edd6b9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.34,28.13,458,30.69c.74,23.68-.87,47.53,4.17,72.07.38,1.82.75,4.27-1.11,5.62s-5.44,1.26-8.15,1.1C317.8,101.27,171,98.93,38.46,108.71c-2.72.2-6.17.24-8.06-1.1s-1.7-3.73-1.35-5.56c4.63-24,4.38-49.74,4.29-73.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.1,20.06c149.22-3.21,311.75-1.28,457.17,2.56-3.72,23.82-.84,49.29-1.47,73.11a22.41,22.41,0,0,0-5.19,6.4c-141.08-6.88-299.81-6.88-443.86-.64a31.76,31.76,0,0,0-5.18-6.42c0-23.67,3.83-51.07-1.47-75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.76,11.74c152.71-3.28,319-1.32,467.85,2.62a574.05,574.05,0,0,0-6.81,81.37c-146.87-3.35-306.39-4.53-454.23-.66.42-26.49-.75-56-6.81-83.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M472.89,90.45c-28.18.65-56.38.23-84.57.84q-21.68.48-43.15,1.32-7.89.31-15.74.67c48.55.54,96.6,1.38,143.37,2.45q0-2.64.09-5.28Zm.3-10c-26.27.89-52.34,1.66-78.72,1.66-25.87,0-63.71,1.44-89.53,3.21q-31,2.13-61.88,5.34c-6.3.64-12.5,1.3-18.64,2q16.82,0,33.65.09c48-4,98.6-6,136.4-6,26.32,0,52.35-.76,78.56-1.65.05-1.55.1-3.1.16-4.66Zm.48-10.07c-20.65.68-40,.94-61.08.49-58.22-1.24-111.74,5.08-168.52,10-14.14,1.22-28.29,2.44-42.16,4.7-11.95,2-23.58,4.54-35.15,7.22L177,92.74c8.29-1.94,16.59-3.69,24.94-5,45.71-7.46,165.93-13.11,210.5-12.16,21,.45,40.38.19,61-.47.07-1.56.15-3.11.24-4.67Zm1.92-24.57c-20.28,2-37.46,2.82-56.12,3.67C349.58,52.66,311.11,61.25,245,70.86c-23.95,3.48-47.07,6.84-72.7,12.4-13.15,2.85-26.11,6.44-39,9.79l15.57-.14c33.19-8,62-14.2,97-19.28,29.6-4.3,75.16-11.86,102.13-14.39,29.55-2.77,51.5-3.76,71.72-4.68C438.14,53.73,455.1,53,475.1,51c.15-1.72.32-3.44.49-5.16Zm2.34-31.5c-12.55,4-28.61,8.66-46.42,12.87-23.26,5.5-44.44,8.71-68.48,11.57-45.7,5.44-88.24,15.29-132.65,23.5-44.14,8.16-86,22.44-126.89,31.14l9.61-.12c8.89-2.37,17.63-5,26.64-7.13,30.63-7.34,61-14.29,92.41-20.09,34.86-6.44,65.9-13.2,102.12-18.71,32.64-5,66-7.42,98.66-15.14,17.49-4.14,33.35-8.72,45.9-12.69q.38-2.58.78-5.16l-1.68,0ZM61.62,10.85a16.51,16.51,0,0,1,2.25,3.08,7.38,7.38,0,0,1,1,3.84,7.42,7.42,0,0,1-1.24,3.72,9.05,9.05,0,0,1-3.21,2.89,33.46,33.46,0,0,1-6.7,2.68,53.43,53.43,0,0,1-8.18,1.67,103.28,103.28,0,0,1-11.1.84A84.22,84.22,0,0,1,24,29.16c-3.12-.32-6.22-.76-9.28-1.32q-.46-3-1-6.05c1.22.4,2.51.77,3.83,1.11a72.69,72.69,0,0,0,29.31,2,34.6,34.6,0,0,0,11.78-3.4,5,5,0,0,0,2.65-4.06c.07-1.78-1.23-3.6-2.63-5.08a18.07,18.07,0,0,0-1.56-1.47l4.48-.07ZM126,10.22c.78,3.67-.32,7.35-6,11.52C91.52,42.82,62,58.55,17.65,54.51c.1,1.49.2,3,.28,4.47,46.65,5.48,79.53-11.65,111.16-35.07,6.42-4.75,10-9.22,9.71-13.75L126,10.22Zm60.91-.13c-.13,1.9-1.33,3.79-3.75,5.44-5.92,4-22.76,12.67-36.53,19C111.05,50.77,102.06,63.06,39.22,68.2A139.16,139.16,0,0,1,18.35,68c0,.81,0,1.61.07,2.41,6.53.31,13.09.42,19.71.23C93,69,112.41,55.14,151.15,37.4c14.72-6.74,34.47-15.78,41.06-20.28a12.71,12.71,0,0,0,3.79-3.9,8.37,8.37,0,0,0,1.13-3.12Zm72.66.35c2.76,5.58-9.65,10-30.3,15.76-11.88,3.29-24.3,6.51-35.51,10.07-26.2,8.31-49.87,22.86-76.52,31.83C84.36,79.16,55.08,82.48,18.63,81.79c0,1.12,0,2.25,0,3.37,35.37.48,65.94-2.37,100.62-14,11.07-3.73,21.44-8,31.81-12.27,16.61-6.84,32.17-12.64,50-18.3,19.31-6.13,42-11.29,60-17.39C273.32,19,276.2,14.7,273.9,10.57l-14.37-.13Zm98.33,1.26c-3.29,2.41-9.21,4.74-16.41,7-18.77,5.86-38.52,10.37-57.75,15.59C212.92,53.5,113.34,90.56,42.92,92.38c-7.86.21-16,.19-24.31,0,0,.89,0,1.78,0,2.67q21.09-.55,42.48-1c33.8-2.53,67.07-9.5,97.44-18.17,18.76-5.36,36.92-11.49,55.7-16.84,25.94-7.4,52.23-14.29,78.38-21.39,20.08-5.45,40.69-10.16,60.29-16.28,6.14-1.92,11.17-4,14.55-6.22a15.27,15.27,0,0,0,3.73-3.26l-13.28-.24ZM16.51,41.47a98.57,98.57,0,0,0,30.08.32A125.47,125.47,0,0,0,63,38.19C73.54,35.12,82.22,31,88,26.72c6-4.45,9-9.12,7.63-13a6.25,6.25,0,0,0-.7-1.42,13.82,13.82,0,0,0-1.46-1.84l-6.56.06c3.83,4,3.67,8.49-3.63,14.28-5,4-12.62,7.87-21.89,10.77A106,106,0,0,1,46.78,39c-10.58,1.73-20.49.88-30.66-1.12q.21,1.79.39,3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.68,21.53a5,5,0,0,0,2.65-4.06c.07-1.78-1.23-3.6-2.63-5.08a18.07,18.07,0,0,0-1.56-1.47q-22.86.33-45.38.82c.74,3.32,1.4,6.68,2,10,1.22.4,2.51.77,3.83,1.11a72.69,72.69,0,0,0,29.31,2,34.6,34.6,0,0,0,11.78-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M95.6,13.74c1.32,3.86-1.59,8.53-7.63,13C82.22,31,73.54,35.12,63,38.19a125.47,125.47,0,0,1-16.42,3.6,98.57,98.57,0,0,1-30.08-.32c.47,4.34.84,8.7,1.14,13C62,58.55,91.52,42.82,120,21.74c5.64-4.17,6.74-7.85,6-11.52q-16.3.09-32.52.26a13.82,13.82,0,0,1,1.46,1.84,6.25,6.25,0,0,1,.7,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M192.21,17.12c-6.59,4.5-26.34,13.54-41.06,20.28C112.41,55.14,93,69,38.13,70.61c-6.62.19-13.18.08-19.71-.23.12,3.83.19,7.64.21,11.41,36.45.69,65.73-2.63,98.57-13.69,26.65-9,50.32-23.52,76.52-31.83,11.21-3.56,23.63-6.78,35.51-10.07,20.65-5.73,33.06-10.18,30.3-15.76q-31.17-.27-62.4-.34A8.37,8.37,0,0,1,196,13.22a12.71,12.71,0,0,1-3.79,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M292.57,37.7c-26.15,7.1-52.44,14-78.38,21.39-18.78,5.35-36.94,11.48-55.7,16.84C128.12,84.6,94.85,91.57,61.05,94.1q21.11-.41,42.44-.7c40.87-8.7,82.75-23,126.89-31.14C274.79,54.05,317.33,44.2,363,38.76c24-2.86,45.22-6.07,68.48-11.57,17.81-4.21,33.87-8.88,46.42-12.87-34.78-.92-70.51-1.73-106.79-2.38a15.27,15.27,0,0,1-3.73,3.26c-3.38,2.22-8.41,4.3-14.55,6.22-19.6,6.12-40.21,10.83-60.29,16.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M18.58,77.09c4.22-21.56,4.07-34.86-.85-62.29,134.5,1.34,275.75-.22,411.32-1.68-135.3-3.07-281.66-4.3-417.29-1.38,4.72,21.31,6.47,43.89,6.82,65.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M102,76.65a174.31,174.31,0,0,0,33.51-10.09c1.35-.54,2.73-1.11,4.13-1.69l1.28-.53,2.94-1.24c19.41-8.2,33.44-12.84,53.43-19.35,15.6-5.07,34.41-10.52,46.71-15.37l-3.56,1c-13.1,3.66-26.94,7.21-39.39,11.16q-4.09,1.29-8,2.61c-2.87,1-5.69,1.92-8.48,2.89q-2.74,1-5.46,1.94-5.18,1.86-10.29,3.81c-5.88,2.25-11.74,4.58-17.74,7.05-3.09,1.27-6.18,2.55-9.29,3.81l-4.25,1.7-1.37.54-3.06,1.19c-4.52,1.75-9.12,3.44-13.84,5-6.11,2.06-12.11,3.84-18,5.38-1.74.46-3.48.89-5.21,1.31q3.13-.57,6-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M191,74.36q-5.85,1.26-11.66,2.57-4.2.93-8.38,1.89Q155.66,82.33,140.34,86l-.6.14c-3.54.85-7,1.77-10.53,2.71C133.13,88,137,87.07,141,86.19l4.92-1.1c9.62-2.12,19.26-4.19,28.9-6.27l2.11-.46,4.34-.93L193,74.87c6.37-1.39,12.75-2.76,19.17-4.05,4.63-.94,9.28-1.82,13.93-2.69,5.27-1,10.74-1.39,16-2.39,11.84-2.24,23.4-5.27,35.11-7.8q2.82-.6,5.61-1.23,5.11-1.14,10.22-2.31l-11.1,2.1c-12.51,2.4-24.94,4.86-37.75,7.3l-2.58.49-1.73.33-7.71,1.44q-4,.73-8,1.5-16.71,3.21-33.13,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.63,61.59c42.29-3.46,79.48-3.93,110.75-6.08q7.19-.48,13.93-1.12,7.26-.68,14-1.57l2.64-.37c0-.49.08-1,.13-1.47l-2.77.27c-4.82.45-9.48.84-14,1.18-10.23.76-19.94,1.27-29.87,1.73l-8.68.4c-20.22.92-42.17,1.91-71.72,4.68-5,.47-10.59,1.11-16.61,1.86-5.12.65-10.54,1.38-16.13,2.16q9.33-.94,18.34-1.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "32.38 22.71 462.38 21.89 444.09 87.85 27.95 82.03 32.38 22.71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingBg08);
export default __webpack_public_path__ + "static/media/Heading BG-08.3472f960864bebf128273323c1a05cd1.svg";
export { ForwardRef as ReactComponent };